import React from 'react';
import ReactTooltip from 'react-tooltip';
import ItemDetails from '../../components/common/ItemDetails';
import ItemUnitOrVariants from '../../components/common/ItemUnitOrVariants';
import JoinScheduleSelector from './JoinScheduleSelector';
import {setSelectedSchedule} from "../../actions/join/joinActions";
import {connect} from 'react-redux';
import {setNoItemImage} from '../../common/utils';
import styles from "../../css/join/joinItemCard.less";

class JoinItemCard extends React.Component {
    state = {
        showDetailsModal: false
    };

    // onChangeSchedule: function(event){
    //     this.props.setSelectedSchedule(this.props.item.key, event.target.value);
    // },
    getSchedules = () => {
        if (!this.props.item.waitList) {
            return (<JoinScheduleSelector item={this.props.item}
                                          schedules={this.props.schedules}
                                          clientViewPort={this.props.clientViewPort}
                                          isFarmSeasonal={this.props.isFarmSeasonal}/>);
        }
    };

    openDetails = () => {
        this.setState({ showDetailsModal: true });
    };

    onCloseClick = () => {
        this.setState({ showDetailsModal: false });
    };

    getItemDetails = () => {
        if (this.state.showDetailsModal) {
            return (
                <ItemDetails item={this.props.item}
                             staticData={this.props.staticData}
                             isJoinFlow={true}
                             isFarmSeasonal={this.props.isFarmSeasonal}
                             schedules={this.props.schedules}
                             pickupSite={this.props.pickupSite}
                             clientViewPort={this.props.clientViewPort}
                             shouldShowQuantityUpdater={true}
                             closeDetails={this.onCloseClick}/>
            )
        }
    };

    render() {
        const item = this.props.item;
        return (
            <div className="join-item-card" name="joinItemCard">
                <div className="item-title" name="item-title" onClick={this.openDetails}>{this.props.item.title}</div>
                <div className="item-image-wrapper" onClick={this.openDetails}>
                    <img className="item-image" src={item.imageUrl} onError={setNoItemImage} data-tip="Click for more details"/>
                    <ReactTooltip effect="solid" offset={{top: -50}}/>
                </div>
                <div className="item-info">
                        <ItemUnitOrVariants
                            clientViewPort={this.props.clientViewPort}
                            item={item}
                            staticData={this.props.staticData}
                            isJoinFlow={true}
                            schedules={this.getSchedules()}
                            isFarmSeasonal={this.props.isFarmSeasonal}
                            pickupSite={this.props.pickupSite}/>
                </div>
                {this.getItemDetails()}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const signupData = (state.signupData || {});
    const summary = (state.summary || {});
    const isWaitListOnly = (signupData.data||{}).isWaitListOnly;
    let item  = ownProps.item;
    let weeksLeft = item.weeksLeft?[]:undefined;
    let schedules = item.schedules?[]:undefined;
    let isDeliveriesLeft = item.isDeliveriesLeft?[]:undefined;
    if(!isWaitListOnly && item.schedules) {
        item.schedules.forEach(function (schedule, index) {
            if (ownProps.schedules.hasOwnProperty(schedule)) {
                schedules.push(schedule);
                if (isDeliveriesLeft) {
                    isDeliveriesLeft.push(ownProps.item.isDeliveriesLeft[index]);
                }
                if (weeksLeft) {
                    weeksLeft.push(ownProps.item.weeksLeft[index]);
                }
            }
        });
        item.schedules = schedules;
        if (weeksLeft) {
            item.weeksLeft = weeksLeft;
        }
        if (isDeliveriesLeft) {
            item.isDeliveriesLeft = isDeliveriesLeft;
        }
    }
    return {
        clientViewPort: (state.clientViewPort || {}),
        staticData: (state.staticData||{}),
        isFarmSeasonal: signupData.data.isFarmSeasonal,
        pickupSite: (summary.pickupSite || {}).key,
        item: item
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedSchedule: (itemKey, scheduleKey) =>{
            dispatch(setSelectedSchedule(itemKey, scheduleKey));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(JoinItemCard);




// WEBPACK FOOTER //
// ./src/containers/join/JoinItemCard.js